<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
      </div>
      <div style="width: 500px;">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="活动名称" prop="activityName">
            <el-input v-model="ruleForm.activityName" placeholder="请输入活动名称" />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker v-model="ruleForm.activityTime" type="daterange" range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="活动说明" prop="activityExplain">
            <el-input v-model="ruleForm.activityExplain" type="textarea" :rows="4" placeholder="请输入活动说明" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="configForm" :model="configForm" :rules="configRules" label-width="100px">
          <el-form-item label="消费维度" prop="consumptionDimension">
            <el-radio-group v-model="configForm.consumptionDimension">
              <el-radio label="2">金额</el-radio>
              <el-radio label="1">电量</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖励标准" prop="amount">
            <div v-if="configForm.consumptionDimension==='1'" class="d-flex amount">
              <div>满</div>
              <el-input v-model="configForm.amount" type="number" placeholder="请输入电度数" />
              <div>度</div>
            </div>
            <div v-if="configForm.consumptionDimension==='2'" class="d-flex amount">
              <div>满</div>
              <el-input v-model="configForm.amount" type="number" placeholder="请输入金额" />
              <div>元</div>
            </div>
          </el-form-item>
          <template v-for="(row,index) in configForm.coupon">
            <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)" prop="coupon">
              <div class="d-flex">
                <el-select v-model="row.couponId" filterable style="width: 200px;" placeholder="请选择优惠券">
                  <el-option v-for="item in allCoupon" :key="item.couponId" :label="item.couponName" :value="item.couponId" />
                </el-select>
                <el-input v-model="row.count" class="ml-20" style="width: 100px;" placeholder="请输入数量" />
                <div class="ml-20">张</div>
                <i class="icon-jia ml-20 el-icon-circle-plus-outline" @click="addCoupon(index)" />
                <i v-show="index!==0" class="icon-jia ml-20 el-icon-remove-outline" @click="delCoupon(index)" />
              </div>
              <div class="d-flex currentStock">当前库存：{{ queryCouponStock(row.couponId) }}</div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { numberfilter } from '@/utils/tool'
export default {
  data() {
    return {
      type: 6,
      ruleForm: {
        activityName: '', // 活动名称
        activityTime: [], // 活动时间
        activityExplain: ''// 活动说明
      },
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        activityExplain: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ]
      },
      // 所有的优惠券数据
      allCoupon: [],
      configForm: {
        consumptionDimension: '2', // 消费维度
        amount: '', // 奖励标准
        coupon: [// 优惠券
          {
            couponId: '', // 优惠券id
            count: '' // 优惠券数量
          }
        ]
      },
      configRules: {
        consumptionDimension: [
          { required: true, message: '请选择消费维度', trigger: 'change' }
        ],
        amount: [
          { required: true, message: '请输入奖励标准', trigger: 'blur' }
        ],
        coupon: { required: true, trigger: 'change', validator: (rewardRules, value, cb) => {
          if (this.couponRule) {
            return cb(new Error(this.couponRule))
          }
          return cb()
        }
        }
      }
    }
  },
  computed: {
    // 优惠券的动态校验
    couponRule() {
      const dataArray = this.configForm.coupon
      for (let i = 0; i < dataArray.length; i++) {
        const currentObj = dataArray[i]
        if (currentObj.couponId === '' && !currentObj.couponId.length) {
          return '请选择优惠券'
        }
        if (!currentObj.count && !currentObj.count.length) {
          return '请输入数量'
        }
        if (this.queryCouponStock(currentObj.couponId) && currentObj.count > this.queryCouponStock(currentObj.couponId)) {
          return '优惠券数量大于库存数量'
        }
      }
      return ''
    }
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      // 加载优惠券数据
      this.loadCoupon()
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000,
        status: 0,
        hasStock: true
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          this.allCoupon = resp.list
        }
      })
    },
    /**
     * 表单添加一行优惠券
     */
    addCoupon(index) {
      const data = {
        couponId: '', // 优惠券id
        count: '' // 优惠券数量
      }
      this.configForm.coupon.splice(index + 1, 0, data)
    },
    /**
     * 删除删除一行优惠券
     */
    delCoupon(index) {
      this.configForm.coupon.splice(index, 1)
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      let val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      val = val || ''
      return val.stock || 0
    },
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })

      let configFormBool = false
      this.$refs['configForm'].validate(valid => {
        configFormBool = valid
      })
      // 如果三个表单都验证通过
      if (ruleFormBool && configFormBool) {
        // 进入提交数据函数
        this.submitData()
      }
    },
    submitData() {
      const data = {
        type: this.type,
        name: this.ruleForm.activityName, // 活动名称
        start: this.ruleForm.activityTime[0], // 活动开始时间
        end: this.ruleForm.activityTime[1], // 活动结束时间
        description: this.ruleForm.activityExplain, // 活动说明
        consumptionType: this.configForm.consumptionDimension, // 消费维度
        coupons: [
          {
            amount: this.configForm.amount,
            coupons: this.configForm.coupon
          }
        ]
      }
      this.$store.dispatch('form/handle', {
        url: '/activity/save',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 1500
          })
          this.$router.go(-1)
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .d-flex{
    display: flex;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .ml-20{
    margin-left: 20px;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  .border{
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
  .amount{
    /deep/.el-input{
      width: 70%;
      padding: 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/firstAdd.vue